<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$_cancle"
    custom-class="greater"
    lock-scroll
    append-to-body
  >
    <div class="content" v-loading="isLoading">
      <div class="filter-wrap">
        <div class="filter-input">
          <input
            v-model.trim="searchKey"
            @keyup.enter="$_filterPlatforms"
            class="filter-input__inner"
            type="text"
            placeholder="运营商名称"
          />
        </div>
        <el-button @click="$_filterPlatforms" class="search__btn">查询</el-button>
        <el-button @click="$_reset" class="reset__btn">重置</el-button>
        <el-button v-if="!isSearched" @click.stop="$_addConfig" class="btn__add">添加</el-button>
      </div>
      <div class="content-box" ref="scrollItem">
        <template v-for="(config, index) in configList">
          <div
            v-show="matchPlatformKeys.length === 0 || ~matchPlatformKeys.indexOf(config.platformKey)"
            :key="index"
            class="config-item"
          >
            <el-button
              v-if="configList.length > 1"
              @click.stop="$_deleteConfig(index)"
              class="reset__btn"
            >删除</el-button>
            <div class="config-item__title">
              <span>配置信息</span>
            </div>
            <el-form
              class="config-item__form"
              ref="configForm"
              label-position="top"
              @submit.native.prevent
            >
              <el-form-item label="账号所属运营商:">
                <el-input
                  disabled
                  v-model="config.platformName"
                  placeholder="必选, 单选"
                  style="width: 440px;"
                ></el-input>
                <el-button @click="$_showSelectPlactform(index, config)" class="select__btn">选择</el-button>

                <div class="input-tips">*必填, 账号所属的运营商</div>
              </el-form-item>

              <el-form-item v-if="config.platformOrgType !== 0" label="账号所属组织:">
                <div v-if="config.platformOrgType !== -1" class="org-wrap">
                  <!-- 运营商组织类型为默认时 选择品牌、门店 -->
                  <div v-if="config.platformOrgType === 0" class="org-type">
                    <!-- S 配置品牌 -->
                    <div class="org-type__1">
                      <label class="org-item__label">配置品牌:</label>
                      <div class="org-item__content">
                        <el-input
                          :value="config.brandList.reduce((prev, curr)=>prev.concat([curr.brandName]),[]).join(', ')"
                          type="textarea"
                          disabled
                          resize="none"
                          placeholder="请选择"
                          class="config-item__textarea"
                        ></el-input>
                        <el-button
                          @click="$_showSelectBrands(index, config)"
                          class="select__btn"
                        >选择品牌</el-button>
                        <div class="input-tips">*选填, 品牌为空即配置所选运营商</div>
                      </div>
                    </div>
                    <!-- E 配置品牌 -->
                    <!-- S 配置门店 -->
                    <div class="org-type__1">
                      <label class="el-form-item__label">配置门店:</label>
                      <div class="org-item__content">
                        <el-input
                          :value="config.storeList.reduce((prev, curr)=>prev.concat([curr.storeName]),[]).join(', ')"
                          type="textarea"
                          disabled
                          resize="none"
                          placeholder="请选择"
                          class="config-item__textarea"
                        ></el-input>
                        <el-button
                          @click="$_showSelectStores(index, config)"
                          class="select__btn"
                        >选择门店</el-button>
                        <div class="input-tips">*选填, 门店为空即配置所选品牌</div>
                      </div>
                    </div>
                    <!-- E 配置门店 -->
                  </div>
                  <!-- 运营商组织类型为自定义时 -->
                  <div v-else class="org-type">
                    <el-input
                      :value="config.orgInfoList.reduce((prev, curr)=>prev.concat([curr.orgName]),[]).join(', ')"
                      type="textarea"
                      disabled
                      resize="none"
                      placeholder="请选择"
                      class="config-item__textarea"
                    ></el-input>
                    <el-button @click="$_showSelectOrgs(index, config)" class="select__btn">选择</el-button>
                    <div class="input-tips">*必填, 可多选</div>
                  </div>
                </div>
                <!-- S 未选择运营商时 -->
                <el-input
                  v-else
                  type="textarea"
                  disabled
                  resize="none"
                  placeholder="请选择运营商"
                  class="config-item__textarea"
                ></el-input>
                <!-- E 未选择运营商时 -->
              </el-form-item>
              <el-form-item v-if="config.platformOrgType !== 0" label="账号所属门店:">
                <div class="org-item__content">
                  <el-input
                    :value="config.orgShopList.reduce((prev, curr)=>prev.concat([curr.storeName]),[]).join(', ')"
                    type="textarea"
                    disabled
                    resize="none"
                    placeholder="请选择"
                    class="config-item__textarea"
                  ></el-input>
                  <el-button @click="$_showUserSelectStores(index, config)" class="select__btn" v-if="config.platformOrgType !== -1">选择</el-button>
                  <div class="input-tips" v-if="config.platformOrgType !== -1">*选填, 可多选</div>
                </div>
              </el-form-item>
              <!-- S 运营商为默认组织类型 -->
              <el-form-item v-if="config.platformOrgType === 0" label="配置品牌:">
                <!-- <label class="org-item__label">配置品牌:</label> -->
                <div class="org-item__content">
                  <el-input
                    :value="config.brandList.reduce((prev, curr)=>prev.concat([curr.brandName]),[]).join(', ')"
                    type="textarea"
                    disabled
                    resize="none"
                    placeholder="请选择"
                    class="config-item__textarea"
                  ></el-input>
                  <el-button @click="$_showSelectBrands(index, config)" class="select__btn">选择品牌</el-button>
                  <div class="input-tips">*选填, 品牌为空即配置所选运营商</div>
                </div>
              </el-form-item>

              <el-form-item v-if="config.platformOrgType === 0" label="配置门店:">
                <div class="org-item__content">
                  <el-input
                    :value="config.storeList.reduce((prev, curr)=>prev.concat([curr.storeName]),[]).join(', ')"
                    type="textarea"
                    disabled
                    resize="none"
                    placeholder="请选择"
                    class="config-item__textarea"
                  ></el-input>
                  <el-button @click="$_showSelectStores(index, config)" class="select__btn">选择门店</el-button>
                  <div class="input-tips">*选填, 门店为空即配置所选品牌</div>
                </div>
              </el-form-item>
              <!-- E 运营商为默认组织类型 -->

              <el-form-item label="选择角色:">
                <label>
                  <el-input disabled v-model="config.roleName" placeholder="必填, 选中的角色对应其功能权限"></el-input>
                  <el-button @click="$_showSelectRole(index, config)" class="select__btn">选择角色</el-button>
                </label>
              </el-form-item>

              <el-form-item label="选择渠道:">
                <el-select v-model="config.fromTypeList" multiple placeholder="全部">
                  <el-option
                    v-for="item in typeList"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <div class="edit__btns">
        <el-button class="save__btn" @click="$_submit">保存</el-button>
        <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
      </div>
    </div>
    <!-- 选择运营商弹窗组件 -->
    <select-platform
      v-if="modal.show === true && modal.template === 'select-platform'"
      :title="modal.title"
      :selected="modal.data"
      :isShowOrg="true"
      cancleTxt="返回"
      @callback="$_callbackPlatform"
      @close="$_close"
    ></select-platform>

    <!-- 选择角色弹窗组件 -->
    <select-role
      v-if="modal.show === true && modal.template === 'select-role'"
      :title="modal.title"
      :presetList="presetList"
      :customList="customList"
      :platformKey="modal.data.platformKey"
      :bindRoleId="modal.data.bindRoleId"
      cancleTxt="返回"
      @submit="$_callbackRole"
      @close="$_close"
    ></select-role>

    <!-- 选择品牌弹窗组件 -->
    <select-brands
      v-if="modal.show === true && modal.template === 'select-brands'"
      :title="modal.title"
      :platformKey="modal.data.platformKey"
      :selecteds="modal.data.brandList"
      :isRequire="false"
      @callback="$_callbackBrands"
      @close="$_close"
    ></select-brands>

    <!-- 选择门店s弹窗组件 -->
    <select-stores
      v-if="modal.show === true && modal.template === 'select-stores'"
      :title="modal.title"
      :platformKey="modal.data.platformKey"
      :brandIds="modal.data.brandIdList"
      :selecteds="modal.data.storeList"
      @callback="$_callbackStores"
      @close="$_close"
    ></select-stores>

    <!-- 选择组织s弹窗组件 -->
    <select-orgs
      v-if="modal.show === true && modal.template === 'select-orgs'"
      :title="modal.title"
      :orgDataList="modal.data.orgDataList"
      :orgSelecteds="modal.data.orgSelecteds"
      @callback="$_callbackOrgs"
      @close="$_close"
    ></select-orgs>

    <!-- 选择账号所属门店s弹窗组件 -->
    <select-userStores
      v-if="modal.show === true && modal.template === 'select-userStores'"
      :title="modal.title"
      :platformKey="modal.data.platformKey"
      :orgIds="modal.data.orgInfoList"
      :selecteds="modal.data.shopSelecteds"
      @callback="$_callbackUserStores"
      @close="$_close"
    ></select-userStores>
  </el-dialog>
</template>

<script>
import * as Utils from "@/plugins/utils";
import SelectPlatform from "@/components/modal-select-platform";
import SelectRole from "./modal-select-role";
import SelectBrands from "@/components/modal-select-brands";
import SelectStores from "./modal-select-stores";
import SelectOrgs from "./modal-select-orgs";
import SelectUserStores from "./modal-select-userstores";
import { typeList } from "./typeList.js";

class ConfigItem {
  constructor() {
    this.platformKey = "";
    this.platformName = "";
    this.platformOrgType = -1;
    this.bindRoleId = 0;
    this.roleName = "";
    this.brandIdList = [];
    this.brandList = [];
    this.storeIdList = [];
    this.storeList = [];
    // this.orgIdList = [];
    this.orgInfoList = [];
    this.orgShopList = [];
    this.fromTypeList = [];
  }
}

export default {
  name: "modal-config-assigned",
  props: {
    title: { type: String, default: "" },
    systemId: { type: Number, default: 0 },
    platformDataList: { type: Array, default: [] }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      searchKey: "",
      isSearched: false, // 记录是否已点击 搜索
      matchPlatformKeys: [], // 过滤运营商s时记录其key
      configList: [], // 配置列表
      currentIndex: -1, // 记录当前操作的配置
      presetList: [], // 预设角色
      customList: [], // 自定义角色
      typeList, //渠道
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      }
    };
  },
  methods: {
    $_reset() {
      this.searchKey = "";
      this.$_filterPlatforms();
    },
    $_filterPlatforms() {
      let searchKey = this.searchKey;
      if (searchKey === "") {
        this.matchPlatformKeys.splice(0);
        this.isSearched = false;
        return false;
      }
      let platforms = this.configList.filter(
        item => ~item.platformName.indexOf(searchKey)
      );
      if (platforms.length > 0) {
        this.matchPlatformKeys = [].concat(
          platforms.reduce((prev, curr) => prev.concat([curr.platformKey]), [])
        );
      } else {
        this.matchPlatformKeys = ["error"];
      }
      this.isSearched = true;
    },
    // 关闭本组件发起的弹窗
    $_close() {
      this.currentIndex = -1;
      this.modal.show = false;
      this.modal.template = "";
      this.modal.data = {};
      this.modal.title = "";
    },
    // 选择组织弹窗回调
    $_callbackOrgs(orgs) {
      let index = this.currentIndex;
      this.configList[index].orgInfoList = orgs.slice();
      // let orgIdList = orgs.reduce((prev, curr) => prev.concat([curr.orgId]), []);
      // this.configList[index].orgIdList = orgIdList.slice();

      //切换组织清空门店
      this.configList[index].orgShopList = [];
    },
    // 显示选择组织弹窗
    async $_showSelectOrgs(index, config) {
      this.isLoading = true;
      let result = await this.$service.post("getOrgList", {
        queryType: 1,
        platformKey: config.platformKey,
        pageNow: 1,
        pageSize: 9999
      });
      this.isLoading = false;
      if (!result.$.checkResult) return false;
      let orgDataList = result.data.map(item => {
        return {
          orgId: item.id,
          ...item
        };
      });
      let orgSelecteds = config.orgInfoList.slice();
      this.currentIndex = index;
      this.modal.data = {
        orgDataList,
        orgSelecteds
      };
      this.modal.title = "选择自定义组织";
      this.modal.template = "select-orgs";
      this.modal.show = true;
    },
    // 账号所属门店弹窗回调
    $_callbackUserStores(UserStores) {
      let index = this.currentIndex;
      this.configList[index].orgShopList = UserStores.slice();
    },
    // 显示账号所属门店弹窗
    $_showUserSelectStores(index, config) {
      let { platformKey, orgShopList, orgInfoList} = config;
      if (this.configList[index].orgInfoList.length === 0) {
        $MessageBox.alert({ content: "请先选择账号所属组织" });
        return false;
      }
      this.currentIndex = index;
      let shopSelecteds = orgShopList.slice();
      this.modal.data = {
        platformKey: platformKey,
        orgInfoList: orgInfoList.map(item => item.orgId),
        shopSelecteds
      };
      this.modal.title = "选择账号所属门店";
      this.modal.template = "select-userStores";
      this.modal.show = true;
    },
    // 切换运营商时清空对应原选数据
    $_changePlatform(index) {
      this.configList[index].bindRoleId = 0;
      this.configList[index].roleName = "";
      this.configList[index].brandIdList = [].concat();
      this.configList[index].brandList = [].concat();
      this.configList[index].storeIdList = [].concat();
      this.configList[index].storeList = [].concat();
      // this.configList[index].orgIdList = [].concat();
      this.configList[index].orgInfoList = [].concat();
      this.configList[index].orgShopList = [].concat();
    },
    // 选择运营商弹窗回调
    $_callbackPlatform(platform) {
      let { platformKey, platformName, orgType } = platform;
      let index = this.currentIndex;
      let prePlatformKey = this.configList[index].platformKey;
      if (this.matchPlatformKeys.length > 0) {
        let index = this.matchPlatformKeys.findIndex(
          item => item === prePlatformKey
        );
        if (index > -1) {
          this.matchPlatformKeys.splice(index, 1, platformKey);
        }
      }
      if (platformKey !== prePlatformKey) {
        this.$_changePlatform(index);
        this.configList[index].platformKey = platformKey;
        this.configList[index].platformName = platformName;
        this.configList[index].platformOrgType = orgType;
      }
    },
    // 显示选择运营商弹窗
    $_showSelectPlactform(index, config) {
      this.currentIndex = index;
      // 处理已选择的运营商数据
      this.modal.data = {
        platformName: config.platformName,
        platformKey: config.platformKey
      };
      this.modal.title = "选择运营商";
      this.modal.template = "select-platform";
      this.modal.show = true;
    },
    // 选择门店弹窗回调
    $_callbackStores(stores) {
      let index = this.currentIndex;
      this.configList[index].storeList = [...stores];
      this.configList[index].storeIdList = stores.reduce(
        (prev, curr) => prev.concat([curr.shopId]),
        []
      );
      this.configList[index].brandList.map(ele => {
        let arr = stores.filter(e => e.brandId == ele.brandId);
        ele.shopInfos = arr;
      });
    },
    // 显示选择门店弹窗
    $_showSelectStores(index, config) {
      let { platformKey, brandIdList, storeList } = config;
      if (platformKey === "") {
        $MessageBox.alert({ content: "请先选择运营商" });
        return false;
      }
      if (brandIdList.length === 0) {
        $MessageBox.alert({ content: "请先选择品牌" });
        return false;
      }
      this.currentIndex = index;
      this.modal.data = {
        platformKey: platformKey,
        brandIdList: brandIdList.length === 0 ? [-1] : [].concat(brandIdList),
        storeList: storeList.concat([])
      };
      this.modal.title = "选择账号所属的数据源";
      this.modal.template = "select-stores";
      this.modal.show = true;
    },
    // 选择品牌弹窗回调
    $_callbackBrands(brands) {
      let index = this.currentIndex;
      brands.map(ele => {
        ele.shopInfos = [];
      });
      this.configList[index].brandList = [...brands];
      this.configList[index].brandIdList = brands.reduce(
        (prev, curr) => prev.concat([curr.brandId]),
        []
      );
      //切换品牌清空门店
      this.configList[index].storeList = [];
      this.configList[index].storeIdList = [];
    },
    // 显示选择品牌弹窗
    $_showSelectBrands(index, config) {
      if (config.platformKey === "") {
        $MessageBox.alert({ content: "请先选择运营商" });
        return false;
      }
      this.currentIndex = index;
      this.modal.data = {
        platformKey: config.platformKey,
        brandList: config.brandList
          .filter(item => item.brandName !== "")
          .concat([])
      };
      this.modal.title = "选择账号所属的数据源";
      this.modal.template = "select-brands";
      this.modal.show = true;
    },
    // 选择角色弹窗回调
    $_callbackRole(role) {
      let index = this.currentIndex;
      this.configList[index].bindRoleId = role.rid;
      this.configList[index].roleName = role.roleName;
      this.$_close();
    },
    // 显示角色选择弹窗
    $_showSelectRole(index, config) {
      if (config.platformKey === "") {
        $MessageBox.alert({ content: "请先选择运营商" });
        return false;
      }

      this.isLoading = true;
      // 先获取角色数据
      this.$service
        .post("getRolesBySystemId", {
          systemId: this.systemId,
          platformKey: config.platformKey,
          status: 1
        })
        .then(result => {
          this.isLoading = false;
          if (result.$.checkResult(result, true)) {
            if (
              typeof result.data.presetList === "undefined" ||
              typeof result.data.customList === "undefined" ||
              (result.data.presetList.length === 0 &&
                result.data.customList.length === 0)
            ) {
              $MessageBox.alert({ content: "此运营无角色数据!" });
              return false;
            }
            this.presetList = [...result.data.presetList];
            this.customList = [...result.data.customList];
            this.currentIndex = index;
            this.modal.title = "选择账号所属的角色";
            this.modal.template = "select-role";
            this.modal.show = true;
            this.modal.data = {
              platformKey: config.platformKey,
              bindRoleId: config.bindRoleId
            };
          }
        });
    },
    // 添加
    $_addConfig() {
      let config = new ConfigItem();
      this.configList.push(JSON.parse(JSON.stringify(config)));
      this.matchPlatformKeys.length > 0 && this.matchPlatformKeys.push("");
      this.$nextTick(() =>{
        this.$refs.scrollItem.scrollTop = this.configList.length * 450;
      });
    },
    // 删除
    $_deleteConfig(index) {
      if (this.configList.length > 1) {
        this.configList.splice(index, 1);
      }
    },
    // 保存
    $_submit() {
      let { configList } = this;
      if (configList.some(item => item.platformKey === "")) {
        $MessageBox.alert({ content: "请选择相应运营商" });
        return false;
      }
      if (configList.some(item => item.bindRoleId === 0)) {
        $MessageBox.alert({ content: "请选择相应角色" });
        return false;
      }
      // 判断自定义组织类型时 组织是否为空
      for (let i = 0, len = configList.length; i < len; i++) {
        let orgInfoList = configList[i].orgInfoList
          ? configList[i].orgInfoList.filter(
              item => item.orgId && item.orgId > 0
            )
          : [];
        if (configList[i].platformOrgType === 1 && orgInfoList.length === 0) {
          $MessageBox.alert({
            content: `运营商【${configList[i].platformName}】 请选择账号所属组织!`
          });
          return false;
        }
      }
      // 运营商key去重判断
      let uniq = [];
      configList.forEach(item => {
        if (!~uniq.indexOf(item.platformKey)) {
          uniq.push(item.platformKey);
        }
      });
      if (uniq.length !== configList.length) {
        $MessageBox.alert({ content: "运营商不能重复!" });
        return false;
      }

      let platformDataList = configList.concat([]);
      this.$emit("submit", { systemId: this.systemId, platformDataList });
    },
    // 关闭本弹窗
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  components: {
    SelectPlatform,
    SelectRole,
    SelectBrands,
    SelectStores,
    SelectOrgs,
    SelectUserStores
  },
  created() {
    if (this.platformDataList.length > 0) {
      this.platformDataList.map(ele => {
        let storeList = [],
          orgInfoList = [],
          orgShopList = [];
        if (ele.platformOrgType === 0) {
          storeList = ele.userBrandShopInfoList.reduce((prev, curr) => {
            curr.shopInfos.map(e => {
              e.brandName = curr.brandName;
              e.brandId = curr.brandId;
            });
            return prev.concat(curr.shopInfos);
          }, []);
        } else if (ele.platformOrgType === 1 && ele.orgInfoList || ele.orgShopList) {
          orgInfoList = ele.orgInfoList.map(item => {
            let { orgId, orgName } = item;
            return {
              orgId,
              orgName
            };
          });
          orgShopList = ele.orgShopList.map(item => {
            let { shopId, storeName, brandId, brandName, storeId} = item;
            return {
              shopId, 
              storeName,
              brandId,
              brandName,
              storeId
            };
          });
        }
        this.configList.push({
          platformKey: ele.platformKey,
          platformName: ele.platformName,
          platformOrgType: ele.platformOrgType,
          bindRoleId: ele.bindRoleId,
          roleName: ele.roleName,
          fromTypeList: ele.fromTypeList,
          brandIdList: ele.userBrandShopInfoList.map(item => item.brandId),
          brandList: ele.userBrandShopInfoList.map(obj => {
            obj.platformName = ele.platformName;
            obj.platformKey = ele.platformKey;
            return obj;
          }),
          storeIdList: storeList.map(obj => obj.shopId),
          orgShopList,
          storeList,
          orgInfoList
        });
      });
    } else {
      let config = new ConfigItem();
      this.configList.push(JSON.parse(JSON.stringify(config)));
    }
  },
  mounted() {
    this.visible = true;
  }
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  padding: 20px 14px 10px;
  overflow: hidden;
  &-box {
    height: 100%;
    overflow-y: auto;
  }
  /deep/ .el-input {
    width: 440px;
  }
}
.filter-wrap {
  position: relative;
  box-shadow:0px 0px 0px 0px rgba(0, 0, 0, 0.15);
  .filter-input {
    position: relative;
    width: 240px;
    height: 50px;
    display: inline-block;
    margin-right: 10px;
    margin-left: 20px;
    &__inner {
      width: 100%;
      height: 32px;
      background-color: #fff;
      background-image: none;
      line-height: 32px;
      border: 1px solid #c9c9cb;
      outline: none;
      padding: 0 12px;
      border-radius: 2px;
      -webkit-appearance: none;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      &:hover {
        border-color: #c0c4cc;
      }
      &:focus {
        outline: none;
        border-color: #1895dd;
      }
    }
    &__icon {
      position: absolute;
      top: 8px;
      right: 10px;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.config-item {
  position: relative;
  border: 1px solid #eee;
  background-color: #f9f9f9;
  margin-bottom: 20px;
  &__title {
    height: 40px;
    line-height: 40px;
    padding-left: 15px;
    color: #535353;
    background-color: #f5f6f7;
    border: 1px solid #eee;
    margin-bottom: -1px;
  }
  &__form {
    padding: 15px;
  }
  &:last-child {
    margin-bottom: 0;
  }
  &__textarea {
    width: 440px;
    height: 68px;
  }
  .select__btn,
  /deep/ .el-textarea {
    vertical-align: middle;
  }
  .select__btn {
    margin-left: 10px;
    border-radius: 3px;
  }
  .reset__btn {
    position: absolute;
    top: 5px;
    right: 10px;
    width: 80px;
    height: 30px;
    z-index: 99;
  }
  .input-tips {
    display: inline-block;
    margin-left: 10px;
  }
}
.org-type {
  &__1 {
    padding: 0 10px;
  }
  .org-item__label {
    font-size: 12px;
    color: #68768a;
    line-height: 28px;
  }
  .org-item__content {
    position: relative;
    font-size: 12px;
  }
}
.org-type,
.org-item__content {
  .select__btn {
    vertical-align: top;
  }
  .input-tips {
    vertical-align: top;
  }
}
.btn__add{
  position: absolute;
  right: 30px;
}
.content-box{
  height: 500px;
}

/deep/ .el-select{
  .el-input .el-select__caret::before{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
